
import { sync } from 'vuex-pathify'

export default {
  props: {
    plan: {
      type: Object,
      default: null
    }
  },
  vessel: {
    box: {
      color: 'white',
      padding: 'sm',
      borderRadius: 'lg',
    },
    title: {
      marginBottom: 'xs'
    },
    label: {
      fontWeight: 'semibold'
    },
    price: {
      fontWeight: 'bold',
      fontSize: 'xl',
      marginTop: 'xs'
    },
    button: {
      $extend: ['box', 'label'],
      borderRadius: 'default',
      paddingY: 'sm',
      cursor: 'pointer'
    }
  },
  computed: {
    selectedPlan: sync('registerForm@plan'),
    email() {
      return this.$contact[this.$i18n.locale].email
    }
  },
  methods: {
    onClick() {
      this.selectedPlan = this.plan.title
      this.$scrollTo('register-section')
    }
  }
}
